export enum ExportDownloadType {
    deviceAccessoriesExport = 'deviceAccessoriesExport',
    devicesExport = 'devicesExport',
    financialExport = 'financialExport',
    groupExport = 'groupExport',
    invoiceExport = 'invoiceExport',
    organizationExport = 'organizationExport',
    patientDossier = 'patientDossier',
    patientQuestionnaireExport = 'patientQuestionnaireExport',
    payoutExport = 'payoutExport',
    practitionerExport = 'practitionerExport',
}
